import React from 'react';
import {map} from 'lodash';
import StatisticsTable from './statistics-table';

interface Props {
  college: {
    sixYearGraduationRateByEthnicity?: {
      name: string;
      percent: number;
    }[];
  };
}

const GraduationByEthnicity = ({college}: Props) => {
  if (!college.sixYearGraduationRateByEthnicity) return null;

  const getRows = () =>
    map(college.sixYearGraduationRateByEthnicity, (group) => ({
      name: group.name,
      values: [`${group.percent}%`],
    }));

  return <StatisticsTable caption="6-Year Graduation Rate by Ethnicity" rows={getRows()} />;
};

export default GraduationByEthnicity;
